import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js/auto";
import { Doughnut } from "react-chartjs-2";
import "./RealTimedata.css";
ChartJS.register(ArcElement, Tooltip, Legend);
export const data = {
  // labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
  datasets: [
    {
      label: "# of Votes",
      data: [35, 22, 13, 2],
      backgroundColor: [
        "rgb(255, 85, 0)",
        "rgb(255, 172, 102)",
        "rgb(255, 206, 153)",
        "rgb(255, 139, 63)",
      ],
    },
  ],
};
const RealTimedata = () => {
  return (
    <div className="container poetsen-one-regular">
      <div className="real-time-data">
        {" "}
        <div className="row">
          <div className="col-lg-8">
            <div className="real-time-info">
              <h4>Real-Time Data</h4>
              <div className="real-time-div">
                <div className="real-time-data-p-left">
                  95.75% <br />
                  <p> MC tokens migrated to BEAM</p>{" "}
                  <div className="dots-tokenomics"></div>
                  <div className="dots-tokenomics-2"></div>
                  <div className="dots-tokenomics-3"></div>
                  <div className="dots-tokenomics-4"></div>
                </div>
                <div className="real-time-data-p-right">
                  <p>
                    MC token was replaced by BEAM token in October 2023, with 1
                    MC equalling 100 BEAM -read more here{" "}
                  </p>{" "}
                </div>
              </div>
              <div className="real-time-div-col2">
                <div className="real-time-data-col2-left">
                  Beam Price <br />
                  29$ <div className="dots-tokenomics"></div>
                  <div className="dots-tokenomics-2"></div>
                  <div className="dots-tokenomics-3"></div>
                  <div className="dots-tokenomics-4"></div>
                </div>
                <div className="real-time-data-col2-right">
                  {" "}
                  Beam Price <br />
                  29$ <div className="dots-tokenomics"></div>
                  <div className="dots-tokenomics-2"></div>
                  <div className="dots-tokenomics-3"></div>
                  <div className="dots-tokenomics-4"></div>
                </div>
              </div>
              <div className="real-time-div-col3">
                <div className="real-time-data-col2-left">
                  Beam Price <br />
                  29$ <div className="dots-tokenomics"></div>
                  <div className="dots-tokenomics-2"></div>
                  <div className="dots-tokenomics-3"></div>
                  <div className="dots-tokenomics-4"></div>
                </div>
                <div className="real-time-data-col2-right">
                  {" "}
                  Beam Price <br />
                  29$ <div className="dots-tokenomics"></div>
                  <div className="dots-tokenomics-2"></div>
                  <div className="dots-tokenomics-3"></div>
                  <div className="dots-tokenomics-4"></div>
                </div>
              </div>
              <div className="real-time-div-col4">
                <div className="real-time-data-col2-left">
                  Beam Price <br />
                  29$ <div className="dots-tokenomics"></div>
                  <div className="dots-tokenomics-2"></div>
                  <div className="dots-tokenomics-3"></div>
                  <div className="dots-tokenomics-4"></div>
                </div>
                <div className="real-time-data-col2-right">
                  {" "}
                  Beam Price <br />
                  29$ <div className="dots-tokenomics"></div>
                  <div className="dots-tokenomics-2"></div>
                  <div className="dots-tokenomics-3"></div>
                  <div className="dots-tokenomics-4"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 real-time-pie-chart">
            <div className="real-time-pie">
              {" "}
              <h4>Treasury</h4>
              <div className="real-time-data-bg">
                <Doughnut data={data} /> <br />
                <div className="real-time-div-col3">
                  <div className="realtime-data-col-right-1">
                    Beam Price <br />
                    29$
                  </div>
                  <div className="realtime-data-col-right">
                    {" "}
                    Beam Price <br />
                    29$
                  </div>
                </div>
                <div className="real-time-div-col4">
                  <div className="realtime-data-col-right-1">
                    Beam Price <br />
                    29$
                  </div>
                  <div className="realtime-data-col-right">
                    {" "}
                    Beam Price <br />
                    29$
                  </div>
                </div>{" "}
                <div className="dots-tokenomics"></div>
                <div className="dots-tokenomics-2"></div>
                <div className="dots-tokenomics-3"></div>
                <div className="dots-tokenomics-4"></div>
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
    </div>
  );
};

export default RealTimedata;
